import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { SearchInput } from './SearchInput.js';
import { useUncontrolledInput } from './useUncontrolledInput.js';
import '@hh.ru/magritte-ui-icon/icon';
import './BaseInput.js';
import 'classnames';
import '@hh.ru/magritte-common-mouse';
import '@hh.ru/magritte-common-text-selection';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-common-use-multiple-refs';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-form-helper';
import './useFocus.js';
import './useInputAriaProps.js';
import '@hh.ru/magritte-ui-typography';

const UncontrolledSearchInput = forwardRef(({ value, onChange, ...restProps }, ref) => {
    const [currentValue, changeHandler] = useUncontrolledInput(value, onChange);
    return jsx(SearchInput, { ...restProps, value: currentValue, onChange: changeHandler, ref: ref });
});
UncontrolledSearchInput.displayName = 'UncontrolledSearchInput';

export { UncontrolledSearchInput };
//# sourceMappingURL=UncontrolledSearchInput.js.map
